import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-add',
  templateUrl: './app-add.component.html',
  styleUrls: ['./app-add.component.css']
})
export class AppAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
